/**
 * Save Reducer
 */

import {
  GET_SAVE_TO_GOV_HISTORY_REQUEST,
  GET_SAVE_TO_GOV_HISTORY_SUCCESS,
  GET_SAVE_TO_GOV_HISTORY_FAILURE,
  SET_SAVE_LOADER_STATUS,
  CLEAR_SAVE_HISTORY,
  SET_SAVE_PAGINATION,
  SAVE_TO_GSTN_REQUEST,
  SAVE_TO_GSTN_SUCCESS,
  SAVE_TO_GSTN_FAILURE,
  DOWNLOAD_JSON_REQUEST,
  DOWNLOAD_JSON_SUCCESS,
  DOWNLOAD_JSON_FAILURE,
  GET_FETCHED_SUMMARY_HISTORY_REQUEST,
  GET_FETCHED_SUMMARY_HISTORY_SUCCESS,
  GET_FETCHED_SUMMARY_HISTORY_FAILURE,
  SET_FETCHED_SUMMARY_PAGINATION,
  CLEAR_FETCHED_SUMMARY_HISTORY,
  SET_SAVE_PAGE_SIZE,
  SET_FETCHED_SUMMARY_PAGE_SIZE,
} from './constants';

const initialState = {
  loaderStatus: false,
  saveHistory: [],
  isLoading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    pageSize: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  lastUpdated: null,
  saveToGstnSuccess: false,
  downloadSuccess: false,
  // Redux page size state
  savePageSize: 10,
  fetchedSummaryPageSize: 10,
  // Fetched Summary state
  fetchedSummaryHistory: [],
  fetchedSummaryLoading: false,
  fetchedSummaryError: null,
  fetchedSummaryPagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    pageSize: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  fetchedSummaryLastUpdated: null,
};

const saveReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SAVE_LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
        isLoading: action.loaderStatus, // Sync both loading states
      };

    case GET_SAVE_TO_GOV_HISTORY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_SAVE_TO_GOV_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        saveHistory: action.payload,
        error: null,
        lastUpdated: new Date().toISOString(),
      };

    case GET_SAVE_TO_GOV_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        saveHistory: [],
      };

    case SET_SAVE_PAGINATION:
      console.log("SET_SAVE_PAGINATIONaction.payload",action.payload)
      return {
        ...state,
        pagination: action.payload,
      };

    case SAVE_TO_GSTN_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        saveToGstnSuccess: false,
      };

    case SAVE_TO_GSTN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        saveToGstnSuccess: true,
      };

    case SAVE_TO_GSTN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        saveToGstnSuccess: false,
      };

    case DOWNLOAD_JSON_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        downloadSuccess: false,
      };

    case DOWNLOAD_JSON_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        downloadSuccess: true,
      };

    case DOWNLOAD_JSON_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        downloadSuccess: false,
      };

    case CLEAR_SAVE_HISTORY:
      return {
        ...state,
        saveHistory: [],
        error: null,
        pagination: initialState.pagination,
        lastUpdated: null,
      };

    // Fetched Summary cases
    case GET_FETCHED_SUMMARY_HISTORY_REQUEST:
      return {
        ...state,
        fetchedSummaryLoading: true,
        fetchedSummaryError: null,
      };

    case GET_FETCHED_SUMMARY_HISTORY_SUCCESS:
      return {
        ...state,
        fetchedSummaryLoading: false,
        fetchedSummaryHistory: action.payload,
        fetchedSummaryError: null,
        fetchedSummaryLastUpdated: new Date().toISOString(),
      };

    case GET_FETCHED_SUMMARY_HISTORY_FAILURE:
      return {
        ...state,
        fetchedSummaryLoading: false,
        fetchedSummaryError: action.payload,
        fetchedSummaryHistory: [],
      };

    case SET_FETCHED_SUMMARY_PAGINATION:
      return {
        ...state,
        fetchedSummaryPagination: action.payload,
      };

    case CLEAR_FETCHED_SUMMARY_HISTORY:
      return {
        ...state,
        fetchedSummaryHistory: [],
        fetchedSummaryError: null,
        fetchedSummaryPagination: initialState.fetchedSummaryPagination,
        fetchedSummaryLastUpdated: null,
      };

    case SET_SAVE_PAGE_SIZE:
      return {
        ...state,
        savePageSize: action.payload,
      };

    case SET_FETCHED_SUMMARY_PAGE_SIZE:
      return {
        ...state,
        fetchedSummaryPageSize: action.payload,
      };

    default:
      return state;
  }
};

export { initialState };
export default saveReducer;
